<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">客户名称</span>
            <el-input
              v-model="listQuery.customerCompanyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务品牌</span>
            <el-input
              v-model="listQuery.brand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
           <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
              v-model="listQuery.name"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
              v-model="listQuery.model"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">订单号码</span>
            <el-input
              v-model="listQuery.customerOrderNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">发票号码</span>
            <el-input
              v-model="listQuery.invoiceNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">开票状态</span>
            <el-select :filterable="true" v-model="listQuery.invoiceStatus" class="filter-item" placeholder="" @change="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">税率</span>
            <el-select :filterable="true" v-model="listQuery.rate" class="filter-item" placeholder="" @change="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in rateOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box" >
            <span class="label">所属公司</span>
            <el-select :filterable="true" v-model="listQuery.titleId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleFilterTitleFocus()" @change="handleFilter">
              <el-option
                v-for="item in getTitleCompanyOptions()"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <el-radio-group v-model="listQuery.receivedStatus" @change="handleFilter">
              <el-radio label="0,2" >未收款</el-radio>
              <el-radio label="3" >已收款</el-radio>
              <el-radio label="4" >无需收款</el-radio>
              <el-radio label="" >全部</el-radio>
            </el-radio-group>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t('table.search') }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t('table.add') }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_BATCH_RECEIVE` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batch-fee')"
          >
            批量收款
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t('table.reset') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
                <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
                <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="rf => { if (rf) tableDataRef[0] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :isShowPagination="false"
              :handleDefaultWidth="80"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :showSummary="true"
              style="height:100% ;overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:operation-action="scope">
                <el-link
                  v-permission="{ pkey: `${permissionName}_FEE` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('fee', scope.row)"
                >
                  收款
                </el-link>
                <el-link
                  v-if="scope.row.receivedStatus !== '未收款'"
                  v-permission="{ pkey: `${permissionName}_FEE` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="warning"
                  @click="handleCommand('refund', scope.row)"
                >
                  退款
                </el-link>
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li
                      v-for="item in tabList"
                      :key="item.id"
                      :class="{ active: activeTab === item.id }"
                      @click="handleTabClick(item)">{{ item.name }}
                  </li>
                </ul>
              </div>
              <ChargeFee v-if="activeTab === 5" ref="ChargeFee" :id="activeId"/>
        </div>
      </div>

    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="'business'"
      :commandState="commandState"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <RegistCharge
      v-if="chargeVisible"
      :visible="chargeVisible"
      :selectRow="selectRow"
      :isRefund="isRefund"
      :title="isRefund ? '登记退款' : '登记收款'"
      :multiWithCurrency="multiWithCurrency"
      @update:visibel="() => chargeVisible = false"
      @submit="getList()"
    />
    <el-button
      type="primary"
      circle
      @click="handleSubMenuCollapse"
      class="subMenuCollapseBtn"
      v-if="!dialogFormVisible"
    >
      {{ isSubMenuCollapse ? '展开' : '收起' }}
    </el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList, postUrl } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { getUserDetailByUserId } from '@/apis/user'
import { CostModel, ArrayRowsItem } from '@/model/Index'
import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import ChargeFee from './chargeFee/Index.vue'
import RegistCharge from './RegistCharge/Index.vue'

import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
import { defaultDateFiveYears, pageVo, pageSizes, numberTimes } from '@/utils/index'
import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import $number from 'number-precision'
import $currency from 'currency.js'

export default defineComponent({
  name: 'Financialfee',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    ChargeFee,
    RegistCharge
    // ContactList,
    // EngineerInfoList,
    // TraceInfo,
    // MarketFee
  },
  setup() {
    const { t } = useI18n()
    const ContactList = ref(null)
    const EngineerInfoList = ref(null)
    // const MarketFee = ref(null)
    const TraceInfo = ref(null)
    const tableDataRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_CHARGEFEE,
      permissionName: permissionName.CHARGEFEE,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      activeRow: {} as any,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        receivedStatus: '0,2',
        titleId: '',
        rate: null,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,

      tabList: [
        // { name: '联系人', id: 1 },
        // { name: '工程师', id: 2 },
        // { name: '市场费', id: 4 },
        // { name: '跟踪信息', id: 3 },
        {
          name: '收费明细',
          id: 5
        }
      ],
      activeTab: 5,

      salesManId: '',
      newHpx: 0,
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      salesManOption: [],
      selectionArray: [],
      titleCompanyOptions: [],
      commandState: 'edit',
      selectcCustomerCompanyId: 0,
      chargeVisible: false,
      isRefund: false,
      achieveType: '',
      accountOption: [],
      selectRow: [],
      statusOption: [],
      rateOption: [],
      async handleCommand(command: string, val?: any) {
        dataMap.commandState = command
        if (command !== 'column') {
          dataMap.activeRow = val
          dataMap.activeId = val ? val.id : 0
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'fee': {
            dataMap.isRefund = false
            const { id, changeStatus } = val
            const onFeeClickFun = () => {
              const businessIds = [id]
              postUrl('business/actions/verify/receive', { ids: businessIds }).then(() => {
                dataMap.chargeVisible = true
                dataMap.selectRow = [val]
              })
            }
            if (changeStatus === '申请取消') {
              ElMessageBox.confirm('此业务正在申请取消，是否继续收款？', {
                title: '提示',
                confirmButtonText: '继续',
                cancelButtonText: '取消'
              }).then(() => onFeeClickFun())
              break
            }
            onFeeClickFun()
          }
            break
          case 'refund': {
            dataMap.isRefund = true
            dataMap.chargeVisible = true
            dataMap.selectRow = [val]
            break
          }
          case 'batch-fee':
            {
              dataMap.isRefund = false
              if (!dataMap.selectionArray.length) {
                return ElMessage.error({
                  message: '请选择业务',
                  duration: 1000
                })
              }

              dataMap.selectcCustomerCompanyId = dataMap.selectionArray[0].customerCompanyId
              for (let i = 0; i < dataMap.selectionArray.length; i++) {
                const item = dataMap.selectionArray[i]
                if (dataMap.selectcCustomerCompanyId !== item.customerCompanyId) {
                  return ElMessage.error({
                    message: '请选择同一个客户公司名称业务',
                    duration: 1000
                  })
                }
              }
              const businessIds = dataMap.selectionArray.map((kk: any) => kk.id)
              postUrl('business/actions/verify/receive', { ids: businessIds }).then(() => {
                dataMap.chargeVisible = true
                dataMap.selectRow = dataMap.selectionArray
              })
            }

            break
        }
      },
      multi(num1: number | string, num2: number | string): number {
        return this.multiWithCurrency(num1, num2, false) as number
      },
      multiWithCurrency(num1: number | string, num2: number | string, isCurrency: boolean): $currency | number {
        if (isCurrency) {
          return $currency($number.times(num1, num2))
        }
        return $number.times(num1, num2)
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabCommand(command: string) {
        if (this.activeTab === 1) {
          if (ContactList.value && ContactList.value) {
            ;(ContactList.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 2) {
          if (EngineerInfoList.value && EngineerInfoList.value) {
            ;(EngineerInfoList.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 3) {
          if (TraceInfo.value && TraceInfo.value) {
            ;(TraceInfo.value as any).handleCommand(command)
          }
        }
      },
      getList() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getPageList('business', {
          ...dataMap.listQuery,
          receivedStatus: dataMap.listQuery.receivedStatus === '' ? undefined : dataMap.listQuery.receivedStatus,
          pageType: 'RECEIVED'
        }).then((res: any) => {
          dataMap.list = res.data?.map((item: any) => {
            return {
              ...item,
              orderFee4: dataMap.numberTimes(item.orderFee, item.amount, true)
            }
          }) || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDateFiveYears[0],
          endTime: defaultDateFiveYears[1],
          receivedStatus: '0,2',
          titleId: '',
          rate: null,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        getDetailById('business', row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = res[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'customerContactIds': {
                  const result = await getUrlList(field.config.url, { companyId: res.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: res.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(res.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('business', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },

      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        // getUrlList('urgency/dropdown').then((res: any) => {
        //   dataMap.urgentOption = res || []
        // })
        // getUrlList('dropdown/BusinessType').then((res: any) => {
        //   dataMap.businessTypeOption = res || []
        // })
        getUrlList('dropdown/BusinessInvoicingStatus').then((res) => {
          dataMap.statusOption = res || []
        })
        getUrlList('feeRate/dropdowns').then((res) => {
          dataMap.rateOption = res
            ? res.map((item: any) => {
              return {
                id: item,
                mark: `${item}%`
              }
            })
            : []
        })
      },
      handleEngineerFocus() {
        getUrlList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      },
      handleFilterTitleFocus() {
        getUrlList('ticketTitle/dropdown').then((res: any) => {
          dataMap.titleCompanyOptions = res || []
        })
      },
      getTitleCompanyOptions() {
        return dataMap.titleCompanyOptions ?? []
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      }
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./financial/Index',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(() => {
      mixinData.initHeight()

      dataMap.listQuery.startTime = defaultDateFiveYears[0]
      dataMap.listQuery.endTime = defaultDateFiveYears[1]
      dataMap.listQuery.receivedStatus = '0,2'
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return {
      t,
      ...toRefs(dataMap),
      ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse,
      tableDataRef
    }
  }
})
</script>
<style lang="scss">
.grid-layout-container {
  .vue-grid-item {
    background: #666;
  }
}
</style>
<style lang="scss" scope>
.statusStyle {
  .status {
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color: #fff;
  }
}

.redStatusStyle {
  .icon-tubiao-40 {
    color: #E74228;
  }

  .status {
    background-color: #E74228;
  }
}

.yellowStatusStyle {
  .icon-tubiao-40 {
    color: #F3D03C;
  }

  .status {
    background-color: #F3D03C;
  }
}

.warming-fp {
  border-radius: 4px;
  border: 1px solid $red;
  color: $red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
